import { Injectable } from '@angular/core';

import {
  PassAmcInformationState,
  PassAmcInformationStore,
  resetPassAmcInformation,
  selectPassengerAmcInformationState,
  setPassAmcInformationApi,
} from '@common/store/pass-amc-information';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { filter, map, pairwise } from 'rxjs/operators';
import { AmcJoiningInformationRequest, DefaultService as ServicingApiService } from 'src/sdk-servicing';

@Injectable()
export class PassAmcInformationStoreService {
  constructor(private _store: Store<PassAmcInformationStore>, private api: ServicingApiService) {}

  private _result$ = this._store.pipe(
    select(selectPassengerAmcInformationState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  get success$(): Observable<PassAmcInformationState> {
    return this._result$.pipe(filter((state) => state.isFailure === false));
  }

  get failure$(): Observable<PassAmcInformationState> {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  public resetPassAmcInformationStore() {
    this._store.dispatch(resetPassAmcInformation());
  }

  public setGetOrderFromApi(request: AmcJoiningInformationRequest) {
    this._store.dispatch(
      setPassAmcInformationApi({
        call: this.api.amcJoiningInformationPost(request),
      })
    );
  }
}
